/**
 * Build a WhatsApp deep-link (wa.me) for the given mobile number.
 * - Strips non-digits
 * - Prepends country code 91 (India) to a bare 10-digit number; a number
 *   stored with its own "+" keeps its country, whatever its length
 *   ("+6591234567" is Singapore, not +91 65912 34567 — see utils/phone)
 * - Returns null when no usable number
 *
 * Optional `text` is URL-encoded into the message field.
 */
export function buildWhatsAppLink(mobile, text = "") {
  if (!mobile) return null;
  const international = String(mobile).trim().startsWith("+");
  let digits = String(mobile).replace(/[^0-9]/g, "");
  if (!digits) return null;
  if (digits.length === 10 && !international) digits = "91" + digits;
  const url = `https://wa.me/${digits}`;
  return text ? `${url}?text=${encodeURIComponent(text)}` : url;
}
